import {
  overParseJson,
  checkAttendantAndFetch,
} from '../utils/requestUtils';

const FILE_MANAGER_LIST_BY_IDT_PARENT = 'https://afiliados.uol.com.br/api/listFoldersFilesByParent.html';
const FILE_MANAGER_LIST_BY_PRODUCT_IDT = 'https://afiliados.uol.com.br/api/listProductFolders.html';
const FILE_MANAGER_SEARCH_BY_TERM_API_URL = 'https://afiliados.uol.com.br/api/searchObjectsByTerm.html';

const HTTP_ERROR = 'HTTP_ERROR';

class FileManagerApi {
  static async getFoldersAndFilesByIdtParent(idtParent) {
    try {
      const fetchResponse = await checkAttendantAndFetch(`${FILE_MANAGER_LIST_BY_IDT_PARENT}?idtParent=${idtParent}`, {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({
          ajax: true,
        }),
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getFoldersByIdtProductSource(idtProduct) {
    try {
      const fetchResponse = await checkAttendantAndFetch(`${FILE_MANAGER_LIST_BY_PRODUCT_IDT}?idtProduct=${idtProduct}`, {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({
          ajax: true,
        }),
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }

  static async getDirectoryByTerm(idtParent, term) {
    return this.apiCheckAttendantAndFetch(`${FILE_MANAGER_SEARCH_BY_TERM_API_URL}?idtParent=${idtParent}&q=${term}`);
  }

  static async apiCheckAttendantAndFetch(url) {
    try {
      const fetchResponse = await checkAttendantAndFetch(url, {
        method: 'POST',
        credentials: 'same-origin',
        body: JSON.stringify({
          ajax: true,
        }),
      });
      const text = await fetchResponse.text();
      const data = overParseJson(text);

      if (fetchResponse.status !== 200) {
        const error = new Error(data.error);
        error.code = HTTP_ERROR;
        error.status = fetchResponse.status;
        throw error;
      }

      return data;
    } catch (error) {
      throw error;
    }
  }
}

export default FileManagerApi;
